import { UserPlus } from 'lucide-react';
import { Button } from '@sara/ui/components/button';
import { useDialog } from '@sara/ui/hooks/use-dialog';
import { useActiveMembership, useActiveOrganization, useOrgSlug } from '../../contexts/auth';
import { InviteMemberDialog, TeamListContainer } from '../../contexts/team';
import { PageHeader } from '../../components/page-header';

export function TeamSettingsPage() {
  const { organization } = useActiveOrganization();
  const { isAdmin } = useActiveMembership();
  const orgSlug = useOrgSlug();
  const inviteDialog = useDialog(InviteMemberDialog);

  return (
    <div className="space-y-12">
      <PageHeader
        title="Team"
        description="People with access to this organization. Admins can invite teammates, change roles, and remove members."
        action={
          organization &&
          isAdmin && (
            <Button
              variant="tinted"
              shape="pill"
              size="sm"
              className="h-8 gap-1.5 px-3 text-xs [&_svg]:size-3.5 sm:h-9 sm:px-4 sm:text-sm sm:[&_svg]:size-4"
              onClick={() => inviteDialog.open({ orgId: organization.id, orgSlug })}
              data-testid="invite-member-button"
            >
              <UserPlus strokeWidth={1.6} />
              Invite teammate
            </Button>
          )
        }
      />

      <section>{organization && <TeamListContainer orgId={organization.id} />}</section>
    </div>
  );
}
